import React, { useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import ReactOtpInput from 'react-otp-input-rc-17';
import classNames from 'classnames';
import Button from '../button';
import Countdown from '../statistic/Countdown';
import Typography from '../typography';
import { DEFAULT_COUNT_DOWN_TIME, EXPIRED_OTP, NUMBER_OF_OTP_INPUT, RE_SEND_TEXT, TITLE_TEXT, } from './interface';
import { getOtpCountTime, isBlockingTime, resetOtpCountTime, setOtpCountBlockTime, setOtpCountTime, } from './utilities';
import { ConfigContext } from '../config-provider';
import Modal from '../modal';
const OtpComponent = (props, ref) => {
    const { titleText = TITLE_TEXT, descriptionText, reSendText = RE_SEND_TEXT, expiredText = EXPIRED_OTP, numInputs = NUMBER_OF_OTP_INPUT, countDownTime = DEFAULT_COUNT_DOWN_TIME, isDisabled, onConfirmOtp, onResend, blockNotifyPopup, prefixCls: customizePrefixCls, className, } = props;
    const [value, setValue] = useState('');
    const [disable, setDisable] = useState(false);
    const [otpCountDownTime, setOtpCountDownTime] = useState(Date.now());
    const [error, setError] = useState();
    const [disabledResend, setDisabledResend] = useState(false);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('', customizePrefixCls);
    const refOtp = useRef(null);
    const refCountDown = useRef(null);
    // function for parent component call
    useImperativeHandle(ref, () => ({
        startOtp: () => {
            var _a;
            (_a = refCountDown.current) === null || _a === void 0 ? void 0 : _a.stopTimer();
            resetOtpCountTime();
            setValue('');
            setError(null);
            setDisabledResend(true);
            setOtpCountDownTime(Date.now() + countDownTime);
        },
        setBlockTime: (time) => {
            var _a;
            if (time) {
                (_a = refCountDown.current) === null || _a === void 0 ? void 0 : _a.stopTimer();
                setOtpCountBlockTime(time, true);
                setDisable(true);
                setOtpCountDownTime(Date.now() + time);
                if (blockNotifyPopup) {
                    blockNotifyPopup();
                }
            }
        },
        setError(text) {
            setError(text);
        },
    }));
    const handleResendOtp = () => {
        setValue('');
        setError(null);
        if (onResend) {
            onResend();
        }
    };
    const handleExpiredOtp = () => {
        if (!isBlockingTime()) {
            setError(expiredText);
        }
        else {
            setDisable(false);
            Modal.destroyAll();
        }
        setDisabledResend(false);
        resetOtpCountTime();
    };
    const onCountDownChange = (time) => {
        setOtpCountTime(time);
    };
    const handleFocus = useCallback(() => { var _a; return (_a = refOtp.current) === null || _a === void 0 ? void 0 : _a.focusInput(value.length); }, [refOtp.current, value]);
    // handle if has block time
    useEffect(() => {
        const blockTime = getOtpCountTime();
        if (blockTime.isBlock) {
            // calculate block time remind when  otp component destroy and mount again
            const currentTime = new Date().getTime();
            const timeDiffer = currentTime - blockTime.startTime;
            if (timeDiffer < blockTime.time) {
                setDisable(true);
                setOtpCountDownTime(Date.now() + blockTime.time - timeDiffer);
                if (blockNotifyPopup) {
                    blockNotifyPopup();
                }
            }
            else {
                resetOtpCountTime();
            }
        }
        else {
            setDisable(isDisabled);
        }
    }, [isDisabled]);
    useEffect(() => {
        if (!refOtp.current)
            return;
        refOtp.current.handleOtpChange = (val) => {
            var _a;
            const otp = val.join('').replace(/\D/g, '');
            setValue(otp);
            (_a = refOtp.current) === null || _a === void 0 ? void 0 : _a.focusInput(otp.length);
            // khi người dùng nhập lại OTP, xóa error msg
            if (error)
                setError(null);
            // auto validate otp when finish typing
            if (otp.length === numInputs) {
                if (onConfirmOtp) {
                    onConfirmOtp(otp);
                }
            }
        };
    }, [refOtp.current, onConfirmOtp]);
    return (React.createElement("div", { className: `otp-container ${className || ''}` },
        React.createElement("div", null,
            React.createElement(Typography.Heading, { level: 6, fontWeight: "semibold", className: "space-mb-10" }, titleText),
            React.createElement(Typography.SubTitle, { level: 3 }, descriptionText)),
        React.createElement("div", { className: "space-mt-32" },
            React.createElement("span", { className: classNames(error && 'otp-error', disable && 'otp-disabled'), onClick: handleFocus },
                React.createElement(ReactOtpInput, Object.assign({}, props, { ref: refOtp, value: value, containerStyle: "otp-container--wrap-style", inputStyle: `otp-container--input-style ${prefixCls}-input typography-title-2 font-semibold`, focusStyle: "otp-container--focus-style", numInputs: numInputs, isDisabled: disable, hasErrored: !!error, isInputNum: true, shouldAutoFocus: true })),
                error && (React.createElement(Typography.Note, { level: 1, type: "danger", className: "space-mt-8 space-mb-0" }, error))),
            React.createElement("div", { className: "space-mt-8" },
                React.createElement(Button, { type: "link", className: "space-pr-4 typography-caption-1 font-medium btn-resend-otp", disabled: disable || disabledResend, onClick: handleResendOtp }, reSendText),
                React.createElement(Countdown, { ref: refCountDown, className: "otp-container--count-down typography-caption-1 font-medium", format: "\u00A0(mm:ss)", value: otpCountDownTime, onFinish: handleExpiredOtp, onChange: onCountDownChange })))));
};
if (process.env.NODE_ENV !== 'production') {
    OtpComponent.displayName = 'OtpComponent';
}
export default React.forwardRef(OtpComponent);
